/* Ayurvedic Wholesale v14: coupon codes in cart page + drawer, search suggestions for the hero search box,
   sticky checkout bar on phones. Loaded with defer from snippets/cart-drawer.liquid (renders on every page). */
(function () {
  'use strict';
  var D = document, W = window;
  var root = (W.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var rupee = function (v) { var n = +v; if (isNaN(n)) return ''; return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  var emit = function (name, d) { try { D.dispatchEvent(new CustomEvent(name, { detail: d })); } catch (e) {} };

  /* ---------------- 0. One price format: the store's money format is "Rs. 0.00"; show ₹ everywhere ---------------- */
  var SKIP = /^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT)$/;
  function rupeeFix(node) {
    if (!node) return;
    if (node.nodeType === 3) { if (node.nodeValue.indexOf('Rs.') > -1 && !SKIP.test(node.parentNode && node.parentNode.nodeName)) node.nodeValue = node.nodeValue.replace(/Rs\.\s?(?=\d)/g, '₹'); return; }
    if (node.nodeType !== 1 || SKIP.test(node.nodeName)) return;
    var w = D.createTreeWalker(node, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { return n.nodeValue.indexOf('Rs.') > -1 && !SKIP.test(n.parentNode.nodeName) ? 1 : 3; } });
    var list = [], n; while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/Rs\.\s?(?=\d)/g, '₹'); });
  }
  rupeeFix(D.body);
  if ('MutationObserver' in W) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { if (ms[i].type === 'characterData') rupeeFix(ms[i].target); else for (var j = 0; j < ms[i].addedNodes.length; j++) rupeeFix(ms[i].addedNodes[j]); }
  }).observe(D.body, { childList: true, subtree: true, characterData: true });

  /* ---------------- 1. Coupon codes ---------------- */
  function codesOf(box) { return (box.getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean); }
  function refreshCart(box) {
    var where = box.getAttribute('data-where');
    if (where === 'page') { location.reload(); return Promise.resolve(); }
    /* cart drawer: re-render it in place */
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j['cart-drawer'] || '', 'text/html');
      var fresh = doc.querySelector('#CartDrawer'), cur = D.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var b = D.getElementById('cart-icon-bubble');
      if (b && j['cart-icon-bubble']) { var bd = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (bd) b.innerHTML = bd.innerHTML; }
      var nb = D.querySelector('#CartDrawer [data-aw-coupon] .aw-cpn__msg');
      return nb;
    }).catch(function () { location.reload(); });
  }
  function setCodes(box, codes, wanted, removing) {
    var msg = box.querySelector('.aw-cpn__msg'), btn = box.querySelector('[data-aw-cpn-apply]');
    box.classList.add('is-busy'); if (btn) btn.disabled = true;
    msg.className = 'aw-cpn__msg'; msg.textContent = removing ? 'Removing…' : 'Checking code…';
    return fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var list = cart.discount_codes || [];
      var hit = wanted && list.filter(function (d) { return String(d.code).toLowerCase() === wanted.toLowerCase(); })[0];
      var status = removing ? 'removed' : hit && hit.applicable ? 'applied' : 'invalid';
      emit('aw:coupon', { code: (wanted || '').toUpperCase(), status: status, where: box.getAttribute('data-where'), value: (cart.total_price || 0) / 100 });
      var text = status === 'applied' ? '“' + wanted.toUpperCase() + '” applied. Your saving is shown below.' : status === 'removed' ? 'Coupon removed.' : '“' + (wanted || '').toUpperCase() + '” is not valid for this cart. Please check the code or its conditions.';
      if (status === 'invalid' && hit) { /* keep the cart clean: drop a code that does not apply */
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.filter(function (c) { return c.toLowerCase() !== wanted.toLowerCase(); }).join(',') }) })
          .then(function () { return { text: text, status: status }; });
      }
      return { text: text, status: status };
    }).then(function (res) {
      try { sessionStorage.setItem('aw_cpn_msg', JSON.stringify({ t: Date.now(), text: res.text, ok: res.status !== 'invalid' })); } catch (e) {}
      if (res.status === 'invalid') { msg.className = 'aw-cpn__msg is-bad'; msg.textContent = res.text; box.classList.remove('is-busy'); if (btn) btn.disabled = false; return; }
      return refreshCart(box).then(function () { showSaved(true); });
    }).catch(function () {
      msg.className = 'aw-cpn__msg is-bad'; msg.textContent = 'Could not apply the code right now. Please try again or apply it at checkout.';
      box.classList.remove('is-busy'); if (btn) btn.disabled = false;
    });
  }
  function showSaved(final) {
    var s = null; try { s = JSON.parse(sessionStorage.getItem('aw_cpn_msg') || 'null'); if (final) sessionStorage.removeItem('aw_cpn_msg'); } catch (e) {}
    if (!s || Date.now() - s.t > 30000) return;
    D.querySelectorAll('[data-aw-coupon] .aw-cpn__msg').forEach(function (m) { m.className = 'aw-cpn__msg ' + (s.ok ? 'is-ok' : 'is-bad'); m.textContent = s.text; });
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-aw-cpn-apply],[data-aw-cpn-remove]');
    if (!a) return;
    var box = a.closest('[data-aw-coupon]'); if (!box) return;
    e.preventDefault();
    var codes = codesOf(box);
    if (a.hasAttribute('data-aw-cpn-remove')) {
      var rm = a.getAttribute('data-aw-cpn-remove');
      setCodes(box, codes.filter(function (c) { return c.toLowerCase() !== rm.toLowerCase(); }), rm, true);
      return;
    }
    var inp = box.querySelector('.aw-cpn__in'), code = (inp.value || '').trim();
    var msg = box.querySelector('.aw-cpn__msg');
    if (!code) { msg.className = 'aw-cpn__msg is-bad'; msg.textContent = 'Please enter a coupon code.'; inp.focus(); return; }
    if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { msg.className = 'aw-cpn__msg is-ok'; msg.textContent = '“' + code.toUpperCase() + '” is already applied.'; return; }
    setCodes(box, codes.concat(code), code, false);
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('aw-cpn__in')) return;
    e.preventDefault();
    var b = e.target.closest('[data-aw-coupon]').querySelector('[data-aw-cpn-apply]'); if (b) b.click();
  });
  showSaved(false);
  setTimeout(function () { showSaved(true); }, 1500); /* again after the theme re-renders the cart totals */

  /* ---------------- 2. Sticky checkout bar on the cart page (phones) ---------------- */
  var bar = D.getElementById('aw-cbar');
  if (bar && 'IntersectionObserver' in W) {
    var main = D.getElementById('checkout');
    var sync = function () {
      var v = D.querySelector('#main-cart-footer .totals__total-value'), t = bar.querySelector('strong');
      if (!v || !t) return;
      var nv = v.textContent.replace(/\s*INR\s*$/, '').trim();
      if (t.textContent !== nv) t.textContent = nv; /* only write on change: the bar sits inside the watched footer */
    };
    sync();
    var foot = D.querySelector('#main-cart-footer .js-contents') || D.getElementById('main-cart-footer');
    if (foot && 'MutationObserver' in W) new MutationObserver(sync).observe(foot.parentNode || foot, { childList: true, subtree: true, characterData: true });
    if (main) new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top > 0;
      bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('button').tabIndex = show ? 0 : -1;
    }).observe(main);
  }

  /* ---------------- 3. Search suggestions for the hero search box ---------------- */
  function attachSuggest(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.__awSg) return; form.__awSg = 1;
    form.classList.add('aw-sg-host');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
    var id = 'aw-sg-' + Math.random().toString(36).slice(2, 7);
    var box = D.createElement('div'); box.className = 'aw-sg'; box.id = id; box.hidden = true; box.setAttribute('role', 'listbox');
    input.setAttribute('aria-controls', id);
    form.appendChild(box);
    var timer = null, last = '', ctrl = null, active = -1;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function items() { return Array.prototype.slice.call(box.querySelectorAll('.aw-sg__opt')); }
    function mark(i) {
      var all = items(); if (!all.length) return;
      active = (i + all.length) % all.length;
      all.forEach(function (el, k) { el.classList.toggle('is-active', k === active); el.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      all[active].scrollIntoView({ block: 'nearest' });
    }
    function render(q, j) {
      var res = (j && j.resources && j.resources.results) || {};
      var qs = (res.queries || []).slice(0, 4), ps = (res.products || []).slice(0, 6), cs = (res.collections || []).slice(0, 3);
      if (!qs.length && !ps.length && !cs.length) {
        box.innerHTML = '<p class="aw-sg__none">No match for “' + esc(q) + '”. Press Search to see all results, or <a href="#aw-finder" data-aw-q="' + esc(q) + '">tell us your concern</a>.</p>';
      } else {
        var h = '';
        if (qs.length) h += '<div class="aw-sg__grp"><p class="aw-sg__h">Suggestions</p><ul role="list">' + qs.map(function (x) {
          return '<li><a class="aw-sg__opt aw-sg__q" role="option" href="' + esc(x.url) + '"><span>' + (x.styled_text || esc(x.text)) + '</span></a></li>'; }).join('') + '</ul></div>';
        if (ps.length) h += '<div class="aw-sg__grp"><p class="aw-sg__h">Products</p><ul role="list" class="aw-sg__ps">' + ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : (p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '');
          var from = +p.price_max > +p.price_min ? 'From ' : '', mrpv = +(p.compare_at_price_min || 0);
          var mrp = mrpv > +p.price ? ' <s>' + rupee(mrpv) + '</s>' : '';
          var item = JSON.stringify({ id: p.handle, pid: p.id, name: p.title, brand: p.vendor, cat: p.type, price: +p.price });
          return '<li class="aw-sg__p" data-aw-item="' + esc(item) + '"><a class="aw-sg__opt" role="option" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="aw-sg__noimg"></span>') +
            '<span class="aw-sg__pt"><span class="aw-sg__n">' + esc(p.title) + '</span><span class="aw-sg__pr">' + from + rupee(p.price) + mrp + (p.available === false ? ' <em>Out of stock</em>' : '') + '</span></span></a></li>'; }).join('') + '</ul></div>';
        if (cs.length) h += '<div class="aw-sg__grp"><p class="aw-sg__h">Categories &amp; brands</p><ul role="list">' + cs.map(function (c) {
          return '<li><a class="aw-sg__opt aw-sg__c" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul></div>';
        h += '<a class="aw-sg__opt aw-sg__all" role="option" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product">See all results for “' + esc(q) + '” →</a>';
        box.innerHTML = h;
      }
      box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
      emit('aw:suggest', { query: q, where: form.getAttribute('data-aw-search') || 'hero', products: ps.length, total: qs.length + ps.length + cs.length });
    }
    function lookup() {
      var q = input.value.trim();
      if (q.length < 3) { close(); last = q; return; }
      if (q === last && !box.hidden) return;
      last = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = W.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) { if (input.value.trim() === q) render(q, j); }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(lookup, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 3 && box.innerHTML) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    D.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('submit', function () { try { sessionStorage.setItem('aw_sloc', form.getAttribute('data-aw-search') || 'hero'); } catch (e) {} });
  }
  function initSuggest() { D.querySelectorAll('form.aw-hero__search, form[data-aw-suggest]').forEach(attachSuggest); }
  initSuggest();
  /* remember where other searches were typed (header box, search page) for GA4 */
  D.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector || !f.querySelector('input[name="q"]') || f.__awSg) return;
    var where = f.closest('.search-modal, details-modal, .header') ? 'header' : f.closest('.template-search, main') ? 'search_page' : 'other';
    try { sessionStorage.setItem('aw_sloc', where); } catch (er) {}
  }, true);
})();
